import { Users } from "@stories/pages/Contractor/Users/Users";

interface UsersViewProps {
  isOpen: boolean;
  handleDrawerOpen: () => void;
}
export const UsersView = ({ isOpen, handleDrawerOpen }: UsersViewProps) => {
  return <Users />;
};
